"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var InvoiceTax_1 = require("./InvoiceTax");
var CreateInvoiceFee = /** @class */ (function () {
    function CreateInvoiceFee(invoice, json) {
        this.total = 0;
        this.notes = '';
        this.taxEnabled = true;
        this.taxes = [];
        if (json) {
            this.name = json.name;
            this.total = json.total;
            this.notes = json.notes;
            this.taxEnabled = json.isTaxEnabled;
            this.taxes = json.taxes.map(function (tax) { return new InvoiceTax_1.CreateInvoiceTax(tax.taxId, tax.amount); });
        }
        this.invoice = invoice;
        this.observeForTaxes();
    }
    CreateInvoiceFee.prototype.setName = function (name) {
        this.name = name;
    };
    CreateInvoiceFee.prototype.setTotal = function (total) {
        this.total = total;
    };
    CreateInvoiceFee.prototype.setNotes = function (notes) {
        this.notes = notes;
    };
    CreateInvoiceFee.prototype.toggleTaxEnabled = function (toggled) {
        this.taxEnabled = toggled;
    };
    Object.defineProperty(CreateInvoiceFee.prototype, "taxTotal", {
        get: function () {
            return this.taxes.reduce(function (total, tax) { return total + tax.amount; }, 0);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * if total, toggled changes, or invoice.taxGroupId is changed, recalculate taxes
     */
    CreateInvoiceFee.prototype.observeForTaxes = function () {
        var _this = this;
        mobx_1.observe(this, function (change) {
            if (['taxEnabled', 'total'].includes(String(change.name))) {
                _this.reAssignTaxes();
            }
        });
        mobx_1.observe(this.invoice, function (change) {
            if (change.name === 'taxGroup') {
                _this.reAssignTaxes();
            }
        });
    };
    CreateInvoiceFee.prototype.reAssignTaxes = function () {
        var _this = this;
        if (this.taxEnabled && this.invoice.taxGroup) {
            this.taxes = this.invoice.taxGroup.taxLines.map(function (taxLine) { return new InvoiceTax_1.CreateInvoiceTax(taxLine.taxId, (taxLine.percent / 100) * _this.total); });
        }
        else {
            this.taxes = [];
        }
    };
    __decorate([
        mobx_1.observable
    ], CreateInvoiceFee.prototype, "invoice", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceFee.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceFee.prototype, "total", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceFee.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceFee.prototype, "taxEnabled", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoiceFee.prototype, "taxes", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoiceFee.prototype, "setName", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceFee.prototype, "setTotal", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceFee.prototype, "setNotes", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceFee.prototype, "toggleTaxEnabled", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoiceFee.prototype, "taxTotal", null);
    __decorate([
        mobx_1.action
    ], CreateInvoiceFee.prototype, "reAssignTaxes", null);
    return CreateInvoiceFee;
}());
exports.CreateInvoiceFee = CreateInvoiceFee;
//# sourceMappingURL=InvoiceFee.js.map